export default () => ({
	apiKey: "AIzaSyBhSioRjIqVgOJbzpqa-xcnZ3L54km6nD8",
	authDomain: "nsl-me.firebaseapp.com",
	databaseURL: "https://nsl-me.firebaseio.com",
	projectId: "nsl-me",
	storageBucket: "nsl-me.appspot.com",
	messagingSenderId: "948164222451",
	appId: "1:948164222451:web:c1f904452a132235074686",
	measurementId: "G-YWBJZDBT23"
});
